var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicroActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE7E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9617 9.1665H16.038C17.4984 9.1665 18.6455 9.16649 19.5412 9.2869C20.4589 9.41029 21.1871 9.66831 21.7592 10.2404C22.3314 10.8126 22.5894 11.5407 22.7128 12.4585C22.8332 13.3541 22.8332 14.5013 22.8332 15.9617V16.0379C22.8332 17.4984 22.8332 18.6455 22.7128 19.5412C22.5894 20.4589 22.3314 21.1871 21.7592 21.7592C21.1871 22.3314 20.4589 22.5894 19.5412 22.7128C18.6455 22.8332 17.4984 22.8332 16.0379 22.8332H15.9617C14.5013 22.8332 13.3541 22.8332 12.4585 22.7128C11.5407 22.5894 10.8126 22.3314 10.2404 21.7592C9.66831 21.1871 9.41029 20.4589 9.2869 19.5412C9.16649 18.6455 9.1665 17.4984 9.1665 16.038V15.9617C9.1665 14.5013 9.16649 13.3541 9.2869 12.4585C9.41029 11.5407 9.66831 10.8126 10.2404 10.2404C10.8126 9.66831 11.5407 9.41029 12.4585 9.2869C13.3541 9.16649 14.5013 9.1665 15.9617 9.1665Z",
    fill: "#EE0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicroActive);
export default __webpack_public_path__ + "static/media/icon-micro-active.3b98244b13bbd8b70f950eb39028fdad.svg";
export { ForwardRef as ReactComponent };